import React from 'react';
import PropTypes from 'prop-types';

import { Paragraph } from 'components/core/Paragraph';
import { Card } from 'components/core/Card';
import { Image } from 'components/core/Image';
import { H2, H3, H4 } from 'components/core/Headline';
import { Button } from 'components/core/Button';
import { SFIcon } from 'components/core/SFIcon';

import podsLogo from 'assets/images/brand/portable-storage/logo-pods-stacked.png';
import packRatLogo from 'assets/images/brand/portable-storage/packRatLogo.png';
import uPackLogo from 'assets/images/brand/portable-storage/logo-upack-stacked.png';

import './portableStoragePromoCards.scss';

export function PortableStoragePromoCards({ isPSP, city, state }) {
	return (
		<div className="section-container portable-storage-promo-cards">
			<div className="section-content promo-cards-group">
				<div className="promo-cards-wrapper">
					<Card className="promo-card">
						<Image
							className="promo-cards-image"
							src={podsLogo}
							alt="portable storage promo card"
						/>
						<div className="promo-cards-body">
							<H4
								className="promo-cards-reason"
								size="tiny"
							>
								<SFIcon icon="star-empty" />
								America's most trusted
							</H4>
							<H4
								className="promo-cards-title"
								size="small"
							>
								PODS Deal
							</H4>
							<Paragraph
								className="promo-cards-text"
								size="tiny"
								light
							>
								Save up to 10% on your order
							</Paragraph>
							<Button
								fullWidth
								className="promo-cards-cta"
								primary
								href="https://www.pods.com/partners/sparefoot"
								target="_blank"
								rel="noopener noreferrer"
							>
								Get Deal
							</Button>
						</div>
					</Card>
				</div>
				<div className="promo-cards-wrapper">
					<Card className="promo-card">
						<Image
							className="promo-cards-image packrat-logo"
							src={packRatLogo}
							alt="portable storage promo card"
						/>
						<div className="promo-cards-body">
							<H4
								className="promo-cards-reason"
								size="tiny"
							>
								<SFIcon icon="star-empty" />
								Best for the urban mover
							</H4>
							<H4
								className="promo-cards-title"
								size="small"
							>
								1-800-PACK-RAT Deal
							</H4>
							<Paragraph
								className="promo-cards-text"
								size="tiny"
								light
							>
								10% off with SPAREFOOT10 promo code
							</Paragraph>
							<Button
								fullWidth
								className="promo-cards-cta"
								primary
								href="https://www.1800packrat.com/?irclickid=R-RTqzWAsxyKR8EwyXTfu3VWUksRBNwFqWtjxQ0&utm_source=Impact&utm_medium=Affiliate&irgwc=1"
								target="_blank"
								rel="noopener noreferrer"
							>
								Get Deal
							</Button>
						</div>
					</Card>
				</div>
				<div className="promo-cards-wrapper">
					<Card className="promo-card">
						<Image
							className="promo-cards-image"
							src={uPackLogo}
							alt="portable storage promo card"
						/>
						<div className="promo-cards-body">
							<H4
								className="promo-cards-reason"
								size="tiny"
							>
								<SFIcon icon="star-empty" />
								Quick &amp; convenient moving
							</H4>
							<H4
								className="promo-cards-title"
								size="small"
							>
								Upack Deal
							</H4>
							<Paragraph
								className="promo-cards-text"
								size="tiny"
								light
							>
								$10 off $100+ on supplies (10BOX)
								<br />
								$20 off $200+ on supplies (SAVE20)
							</Paragraph>
							<Button
								fullWidth
								className="promo-cards-cta"
								primary
								href="https://www.kqzyfj.com/click-8367506-12188931"
								target="_blank"
								rel="noopener noreferrer"
							>
								Get Deal
							</Button>
						</div>
					</Card>
				</div>
			</div>
		</div>
	);
}

PortableStoragePromoCards.propTypes = {
	city: PropTypes.string.isRequired,
	isPSP: PropTypes.bool.isRequired,
	state: PropTypes.string.isRequired
};

export default PortableStoragePromoCards;
